import React, {Fragment} from 'react'
import {Route, Trip} from 'data/records'
import {Trip as TripV2} from 'lib/api/records'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import {errorMessage} from 'lib/styleguide/base.scss'
import PropTypes from 'prop-types'

export const DELETE_TROUTE_DIALOG = 'DELETE_TROUTE_DIALOG'
export const DELETE_TROUTES_DIALOG = 'DELETE_TROUTES_DIALOG'

const trouteType = PropTypes.oneOfType([
  PropTypes.instanceOf(Route),
  PropTypes.instanceOf(Trip),
  PropTypes.instanceOf(TripV2)
])

class DeleteDialog extends React.PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    confirmMessage: PropTypes.any.isRequired,
    confirmText: PropTypes.any.isRequired,
    deleteErrorMessage: PropTypes.any.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      deletePending: false,
      deleteError: false
    }
  }

  onConfirm = () => {
    const {onConfirm, onRequestClose} = this.props

    this.setState({deletePending: true})
    onConfirm()
      .then(onRequestClose)
      .catch(() => this.setState({deletePending: false, deleteError: true}))
  }

  render () {
    const {
      onRequestClose,
      confirmMessage,
      deleteErrorMessage,
      confirmText,
      title
    } = this.props
    const {
      deletePending,
      deleteError
    } = this.state

    return (
      <ConfirmationDialog
        primary danger
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={deletePending}
        confirmText={confirmText}
        title={title}>
        {confirmMessage}
        {deleteError && <div className={errorMessage}>
          {deleteErrorMessage}
        </div>}
      </ConfirmationDialog>
    )
  }
}

export class DeleteTRoute extends React.PureComponent {
  static propTypes = {
    troute: trouteType.isRequired
  }

  render () {
    const {troute, ...props} = this.props

    const typeStr = troute instanceof Route ? 'Route' : 'Trip'

    return <DeleteDialog
      title={<Fragment>Delete <strong>{troute.name}</strong>?</Fragment>}
      confirmText={'Permanently Delete ' + typeStr}
      confirmMessage={<p>
        Are you sure you want to delete your {typeStr}, <strong>{troute.name}</strong>?
        <br />This action cannot be undone.
      </p>}
      deleteErrorMessage={`Oops, we encountered an error while deleting this ${typeStr}. Please try again.`}
      {...props} />
  }
}

export class DeleteTRoutes extends React.PureComponent {
  static propTypes = {
    troutes: PropTypes.oneOfType([
      PropTypes.array,
      trouteType
    ]).isRequired
  }

  render () {
    const {troutes, ...props} = this.props

    if (Array.isArray(troutes) && troutes.length > 1) {
      const typeStr = troutes.length >= 1 ? (troutes[0] instanceof Route ? 'Route' : 'Trip') : 'object'
      const deleteStr = <Fragment>{troutes.length} {typeStr}{troutes.length > 1 && 's'}</Fragment>

      return (<DeleteDialog
        title={<Fragment>Delete <strong>{deleteStr}</strong>?</Fragment>}
        confirmMessage={<p>
          Are you sure you want to delete <strong>{deleteStr}</strong>?
          <br />This action cannot be undone.
        </p>}
        confirmText={<Fragment>Permanently Delete {deleteStr}</Fragment>}
        deleteErrorMessage={`Oops, we encountered an error while deleting these ${typeStr}s. Please try again.`}
        {...props}
      />)
    } else {
      const troute = Array.isArray(troutes) ? troutes[0] : troutes
      return <DeleteTRoute troute={troute} {...props} />
    }
  }
}
